import api from './api';

/**
 * Servicio para obtener estadísticas del dashboard de administrador
 */
const dashboardService = {
  /**
   * Obtener estadísticas del dashboard
   * @returns {Promise<Object>} Estadísticas del dashboard
   */
  async getDashboardStats() {
    try {
      const response = await api.get('/dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas del dashboard:', error);
      throw error;
    }
  }
};

export default dashboardService;

